<template>
  <div class="user-absence-page">
    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
      <div slot="header" class="row align-items-center">
        <div class="col-lg-6">
          <h6 class="text-uppercase ls-1 mb-1">Absensi Siswa</h6>
        </div>
        <div class="col-lg-6 text-lg-right"></div>
      </div>
      <div class="text-center text-muted">
        <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
          <div class="p-2">
            <b-row>
              <b-col lg="1" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.classId" name="classId" v-validate="'required'" value-field="id" placeholder="Kelas" text-field="name" data-vv-as="Kelas" :options="classList">
                    <b-form-select-option :value="null" disabled>Pilih Kelas</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.tahun_ajaran_id" name="tahun_ajaran_id" v-validate="'required'" value-field="id" text-field="name" placeholder="Tahun Ajaran" data-vv-as="Tahun Ajaran" :options="taList">
                    <b-form-select-option :value="null" disabled>Pilih Tahun Ajaran</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="1" class="my-1">
                <b-input-group size="sm">
                  <b-form-select
                    v-model="filter_form.semester"
                    name="semester"
                    v-validate="'required'"
                    value-field="id"
                    placeholder="Semester"
                    text-field="name"
                    data-vv-as="Semester"
                    :options="semesterList"
                    @change="getSubjectListFilter(filter_form)"
                  >
                    <b-form-select-option :value="null" disabled>Semester</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col>
              <!-- <b-col lg="2" class="my-1">
                <b-input-group size="sm">
                  <b-form-select v-model="filter_form.subjectId" name="subjectId" v-validate="'required'" value-field="id" placeholder="Mata Pelajaran" text-field="name" data-vv-as="Mata Pelajaran" :options="subjectList">
                    <b-form-select-option :value="null" disabled>Pilih Mata Pelajaran</b-form-select-option>
                  </b-form-select>
                </b-input-group>
              </b-col> -->
              <b-col lg="4" class="my-1">
                <b-input-group size="sm">
                  <b-form-datepicker id="start-date" v-model="filter_form.startDate" name="startDate" placeholder="Dari Tanggal" v-validate="'required'"></b-form-datepicker>
                </b-input-group>
              </b-col>
              <b-col lg="4" class="my-1">
                <b-input-group size="sm">
                  <b-form-datepicker id="end-date" v-model="filter_form.endDate" name="endDate" placeholder="Sampai Tanggal" v-validate="'required'"></b-form-datepicker>
                  <b-input-group-append>
                    <!-- <b-button
                      variant="primary"
                      :disabled="!filter_form.classId || !filter_form.tahun_ajaran_id || !filter_form.subjectId || !filter_form.startDate || !filter_form.endDate"
                      style="border-radius: 0px !important"
                      class="btn btn-primary"
                      @click="getUserAbsence(filter_form)"
                      >Filter</b-button
                    > -->
                    <b-button
                      variant="primary"
                      :disabled="!filter_form.classId || !filter_form.tahun_ajaran_id || !filter_form.startDate || !filter_form.endDate"
                      style="border-radius: 0px !important"
                      class="btn btn-info"
                      @click="downloadExcel(filter_form)"
                      >Download</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <div style="overflow-x: auto" v-if="!isBusy">
              <table
                id="user-absence"
                class="table table-absence"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                :sort-direction="sortDirection"
                responsive
                show-empty
                small
                @filtered="onFiltered"
              >
                <thead>
                  <tr v-for="(item, index) in userAbsenceList.header" :key="index">
                    <th class="t-column-header" v-bind:rowspan="column.rowspan" v-bind:colspan="column.colspan" v-for="(column, indexColumn) in item.columns" :key="indexColumn">{{ column.label }}</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr v-if="!userAbsenceList.body" class="text-center">
                    <td colspan="15">Data tidak ditemukan</td>
                  </tr>
                  <tr v-else v-for="(item, index) in userAbsenceList.body" :key="index">
                    <td class="t-column-body" v-bind:rowspan="column.rowspan" v-for="(column, indexColumn) in item.columns" :key="indexColumn">{{ column.label }}</td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "../../../axiosHelper";
// import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
export default {
  props: {
    type: {
      type: String,
      default: null,
    },
    semesterList: {
      type: Array,
      default() {
        return [
          {
            id: "1",
            name: "Ganjil",
          },
          {
            id: "2",
            name: "Genap",
          },
        ];
      },
    },
  },
  components: {
    // SquareLoader
  },
  data() {
    return {
      isBusy: false,
      showLoader: false,
      items: [],
      fields: [
        { key: "name", label: "Nama Lengkap", sortable: true, sortDirection: "asc", class: "text-left" },
        { key: "class_name", label: "Kelas", sortable: true, class: "text-left" },
        { key: "subject_name", label: "Mata Pelajaran", sortable: true, class: "text-left" },
        { key: "absence", label: "Keterangan", sortable: false, class: "text-center" },
      ],
      filter_form: {
        tahun_ajaran_id: null,
        classId: null,
        semester: null,
        subjectId: null,
        startDate: null,
        endDate: null,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100, 200, 400, 800, 1000],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      userAbsenceList: "getUserAbsenceList",
      classList: "getClassList",
      subjectList: "getSubjectListFilter",
      token: "getToken",
      taList: "getTaList",
    }),
  },
  methods: {
    downloadExcel(param) {
      let token = this.token;
      let classId = param.classId;
      let taId = param.tahun_ajaran_id;
      let semester = param.semester;
      let subjectId = param.subjectId;
      let startDate = param.startDate;
      let endDate = param.endDate;
      let route = axios.defaults.baseURL + "/v1/absences/download/" + classId + "/" + taId + "/" + semester + "/" + subjectId + "/" + startDate + "/" + endDate + "?token=" + token;
      window.open(route);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getUserAbsence(form) {
      this.getUserAbsenceList(form);
    },
    async getTaList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getTaList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getUserAbsenceList(form) {
      this.isBusy = true;
      let classId = form.classId;
      let taId = form.tahun_ajaran_id;
      let semester = form.semester;
      let subjectId = form.subjectId;
      let startDate = form.startDate;
      let endDate = form.endDate;
      await this.$store
        .dispatch("getUserAbsenceList", { classId, taId, semester, subjectId, startDate, endDate })
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getClassList() {
      this.isBusy = true;
      await this.$store
        .dispatch("getClassList")
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
    async getSubjectListFilter(param) {
      this.isBusy = true;
      let classId = param.classId;
      let semester = param.semester;
      await this.$store
        .dispatch("getSubjectListFilter", { classId, semester })
        .then(() => {
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          this.$swal.fire("Failed", err.response.data.message, "error");
        });
    },
  },
  destroyed() {
    let resp = null;
    this.$store.commit("setUserAbsenceList", { resp });
  },
  mounted() {
    this.totalRows = this.userAbsenceList.length;
  },
  async created() {
    await this.getClassList();
    await this.getTaList();
  },
};
</script>
<style lang="css" scoped>
.line-with-icon svg {
  /* color: #adb7be; */
  position: absolute;
  left: 0;
  top: 0;
  font-size: 1rem;
}
.line-with-icon {
  position: relative;
  padding: 0 0 0 1.75em;
  margin: 0 0 1em;
}
.user-article a {
  color: black;
}
.class-list > .line-with-icon > a {
  color: #ca062a;
}
.user-article a:hover {
  color: #ca062a;
}

.btn-open-answer {
  color: #6c757d;
}
.btn-open-answer:hover {
  color: #ca062a;
}
#user-absence {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#user-absence td,
#user-absence th {
  border: 1px solid #ddd;
  padding: 8px;
}

#user-absence tr:nth-child(even) {
  background-color: #f2f2f2;
}

#user-absence tr:hover {
  background-color: #ddd;
}

#user-absence th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #d40000;
  color: white;
}
.table-absence {
  width: 100%;
  margin: 20px auto;
  table-layout: auto;
  border: 1px solid #555;
  border-width: 0 1px 0 1px;
}
.t-column-header {
  border: 1px solid #555;
  border-width: 0px 1px 0px 1px;
}
.t-column-body {
  border: 1px solid #555;
  border-width: 1px 1px 1px 1px;
}
</style>
